import React from 'react';
import { ALWAYS_ON_TOP_SETTING_KEY, isAlwaysOnTop } from '../../../../../utility/alwaysOnTop';

// Pins the field above the ones it overlaps, so it cannot be hidden underneath
// another field however the two were placed. See utility/alwaysOnTop.js for the
// stacking the option buys, and form_builder/templatetags/positions.py for the
// same rule applied to the printed form.
const AlwaysOnTopSetting = ({ element, onChange }) => {
  const checked = isAlwaysOnTop(element);

  const handleChange = (e) => {
    if (!element?.id || !onChange) return;
    onChange(e.target.checked, ALWAYS_ON_TOP_SETTING_KEY, element.id);
  };

  return (
    <div className="property-item">
      <h3 className="form-builder-aside-property-sub-title">Always on Top</h3>
      <div className="form-switcher">
        <input type="checkbox" name={ALWAYS_ON_TOP_SETTING_KEY} checked={checked} onChange={handleChange} />
        <span>{checked ? 'Yes' : 'No'}</span>
      </div>
    </div>
  );
};

export default AlwaysOnTopSetting;
